// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__SVLWw","notes":"Notes_notes__2E5cK"};